export enum FolderWatchFallbackReason {
  Errors = 0,
  MissedChange = 1,
}
